import { useState, useEffect } from "react";
import { LangProvider } from "./i18n";
import { LangToggle } from "./LangToggle";
import { HomePage } from "./HomePage";
import { PrivacyPage } from "./PrivacyPage";
import { TermsPage } from "./TermsPage";
import "./index.css";

function getPath() {
  return window.location.pathname;
}

export function App() {
  const [path, setPath] = useState(getPath);

  useEffect(() => {
    const onPop = () => setPath(getPath());
    window.addEventListener("popstate", onPop);
    return () => window.removeEventListener("popstate", onPop);
  }, []);

  // Intercept link clicks for client-side navigation
  useEffect(() => {
    const onClick = (e: MouseEvent) => {
      const anchor = (e.target as HTMLElement).closest("a");
      if (!anchor) return;
      const href = anchor.getAttribute("href");
      if (!href || href.startsWith("http") || href.startsWith("mailto:")) return;

      e.preventDefault();
      window.history.pushState(null, "", href);
      setPath(href);
      window.scrollTo(0, 0);
    };
    document.addEventListener("click", onClick);
    return () => document.removeEventListener("click", onClick);
  }, []);

  let page;
  if (path === "/privacy") page = <PrivacyPage />;
  else if (path === "/terms") page = <TermsPage />;
  else page = <HomePage />;

  return (
    <LangProvider>
      <LangToggle />
      {page}
    </LangProvider>
  );
}

export default App;
